import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useTransactionTypeSelectOptions } from "components/UI/Selects/TransactionTypeSelectSearchable/useTransactionTypeSelectOptions.ts";

export const TransactionTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useTransactionTypeSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.conversion_type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};